import mod from "-!./component.js?vue&type=script&lang=js&"; export default mod; export * from "-!./component.js?vue&type=script&lang=js&"